module.exports = __webpack_public_path__ + "static/sailorsHaven.a21fdae2.jpg";